import { FilterName, ListingType } from '../../../__generated__/fed-graphql-types'
import { Platform } from '@at/sauron-platform-core'

import { asFormattedString } from '@at/formatter-utils/lib/number-utils/number.utils'
import { DeepWriteable } from '../../deep-writeable'
import {
    SearchResultsFacetsWithGroupsQuery_searchResults_SearchResults_facets_Facet,
    SearchResultsFacetsWithGroupsQuery_searchResults_SearchResults_facets_Facet_filters_Filter,
    SearchResultsFacetsWithGroupsQuery_searchResults_SearchResults_facets_Facet_filters_Filter_options_Option,
    SearchResultsFacetsWithGroupsQuery_searchResults_SearchResults_facets_Facet_filters_Filter_sections_FilterSection,
} from '../../../contexts/search-results-context/query/__generated__/search-results-facets.fed.query'

export const setFilterSelectedOptions = (
    facets: DeepWriteable<SearchResultsFacetsWithGroupsQuery_searchResults_SearchResults_facets_Facet[]>,
    filterName: FilterName,
    values: OptionValue[]
) => {
    const facet = facets.find(({ filters }) => filters.find(({ filter }) => filter === filterName))

    if (facet) {
        const filter = facet.filters.find(({ filter }) => filter === filterName)

        if (filter) {
            filter.selected = values.map((value) => String(value))
        }
    }
}

export type OptionValue = string | number | boolean | undefined

export type Option = Omit<
    SearchResultsFacetsWithGroupsQuery_searchResults_SearchResults_facets_Facet_filters_Filter_options_Option,
    'value' | '__typename'
> & {
    value: OptionValue
}

type FilterSection = Omit<
    SearchResultsFacetsWithGroupsQuery_searchResults_SearchResults_facets_Facet_filters_Filter_sections_FilterSection,
    'values' | '__typename'
> & {
    values: readonly OptionValue[]
}

export type Filter = Omit<
    SearchResultsFacetsWithGroupsQuery_searchResults_SearchResults_facets_Facet_filters_Filter,
    'options' | 'sections' | 'selected' | '__typename'
> & {
    options: readonly Option[]
    selected: readonly OptionValue[] | null
    sections?: readonly FilterSection[]
}

export type Facet = Omit<
    SearchResultsFacetsWithGroupsQuery_searchResults_SearchResults_facets_Facet,
    'filters' | '__typename'
> & {
    filters: readonly Filter[]
}

export const prominenceLabelText = (listingType: ListingType | null) => {
    switch (listingType) {
        case ListingType.FEATURED_LISTING:
        case ListingType.PROMOTED_LISTING:
            return 'ad'
        case ListingType.LEASING_LISTING:
        case ListingType.YOU_MAY_ALSO_LIKE:
            return 'You may also like'
        case ListingType.NATURAL_LISTING:
        default:
            return null
    }
}

export const numberOfResultsFoundValue = (total: number | null): string[] => {
    const value = `${asFormattedString(total || 0)}`
    const suffix = total === 1 ? ' result' : ' results'
    return [value, suffix]
}

export const numberOfResultsFoundMessage = (total: number | null): string => {
    const [value, suffix] = numberOfResultsFoundValue(total)
    return `${value}${suffix}`
}

export const perfImgAttrIndex = (platform: Platform) => {
    return platform === Platform.desktop ? 3 : 2
}
